import { render, staticRenderFns } from "./ConfigParams.vue?vue&type=template&id=6c656f46&scoped=true&"
import script from "./ConfigParams.vue?vue&type=script&lang=js&"
export * from "./ConfigParams.vue?vue&type=script&lang=js&"
import style0 from "./ConfigParams.vue?vue&type=style&index=0&id=6c656f46&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c656f46",
  null
  
)

export default component.exports